(function () {
  'use strict';

  const CACHE_PREFIX = 'fabric_stock_';
  const BADGE_ATTR   = 'data-stock-injected';
  const EXCLUDE      = ['all', 'frontpage', 'vendors', 'types'];

  function getHandle(href) {
    const match = href.match(/\/collections\/([^/?#]+)/);
    if (!match) return null;
    const handle = match[1];
    return EXCLUDE.includes(handle) ? null : handle;
  }

  function getCached(handle) {
    try {
      const raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      const { qty, ts } = JSON.parse(raw);
      if (Date.now() - ts > 5 * 60 * 1000) return null;
      return qty;
    } catch { return null; }
  }

  function setCache(handle, qty) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ qty, ts: Date.now() }));
    } catch {}
  }

  async function fetchStockForHandle(handle) {
    const cached = getCached(handle);
    if (cached !== null) return cached;

    let total = 0;
    let url = `/collections/${handle}/products.json?limit=250`;

    while (url) {
      const res = await fetch(url);
      if (!res.ok) break;
      const data = await res.json();
      for (const product of data.products ?? []) {
  if (product.variants?.some(v => v.available === true)) total++;
}
      const linkHeader = res.headers.get('Link') ?? '';
      const nextMatch = linkHeader.match(/<([^>]+)>;\s*rel="next"/);
      url = nextMatch ? nextMatch[1] : null;
    }

    setCache(handle, total);
    return total;
  }

  function createBadge(qty) {
    const span = document.createElement('span');
    span.className = 'stock-badge';
    span.textContent = qty > 0 ? `${qty} dispo` : 'Épuisé';
    span.setAttribute(BADGE_ATTR, '1');
    span.style.cssText = [
      'display:inline-flex',
      'align-items:center',
      'margin-left:6px',
      'padding:2px 7px',
      'font-size:11px',
      'font-weight:500',
      'border-radius:99px',
      'line-height:1.4',
      qty > 0
        ? 'background:rgba(15,110,86,0.12);color:#0f6e56'
        : 'background:rgba(163,45,45,0.12);color:#a32d2d',
    ].join(';');
    return span;
  }

  async function injectBadge(linkEl) {
    if (linkEl.hasAttribute(BADGE_ATTR)) return;
    const handle = getHandle(linkEl.getAttribute('href') ?? '');
    if (!handle) return;
    linkEl.setAttribute(BADGE_ATTR, 'pending');
    try {
      const qty = await fetchStockForHandle(handle);
      linkEl.querySelector(`[${BADGE_ATTR}]`)?.remove();
      linkEl.appendChild(createBadge(qty));
      linkEl.setAttribute(BADGE_ATTR, '1');
    } catch {
      linkEl.removeAttribute(BADGE_ATTR);
    }
  }

  function injectAll(root) {
    root.querySelectorAll(`a[href*="/collections/"]:not([${BADGE_ATTR}])`)
        .forEach(link => injectBadge(link));
  }

  function init() {
    injectAll(document);
    setTimeout(() => injectAll(document), 500);
    setTimeout(() => injectAll(document), 1500);

    const observer = new MutationObserver(() => injectAll(document));
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('mouseover', (e) => {
      const menuItem = e.target.closest('.menu-list__list-item, .header-menu');
      if (menuItem) injectAll(menuItem);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();